
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vcms/vex/vn/ve-may-bay/[slug]/desktop",
      function () {
        return require("private-next-pages/vcms/vex/vn/ve-may-bay/[slug]/desktop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vcms/vex/vn/ve-may-bay/[slug]/desktop"])
      });
    }
  